import { API_URLs } from "../../utilities/API_URLs";
import { Http } from "../../utilities/axios/http";

export class StaffPostService {
  static getAllStaffPostSelect = async (params?: any) => {
    try {
      return await Http.get(API_URLs.staffPost.getStaffPostSelect, params);
    } catch (error) {
      return error;
    }
  };
}
